import { render, staticRenderFns } from "./channelManagement.vue?vue&type=template&id=3eeeebf7&scoped=true&"
import script from "./channelManagement.vue?vue&type=script&lang=js&"
export * from "./channelManagement.vue?vue&type=script&lang=js&"
import style0 from "./channelManagement.vue?vue&type=style&index=0&id=3eeeebf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eeeebf7",
  null
  
)

export default component.exports